import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projectmaster-form',
  templateUrl: './projectmaster-form.component.html',
  styleUrls: ['./projectmaster-form.component.css']
})
export class ProjectmasterFormComponent implements OnInit {
  title="Project Master"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/project-master/projectmaster-form/projectmaster-form.component.ts